export default "__VITE_ASSET__CXmYIaz7__"